/**
 * Método para filtrar uma lista a partir de uma propriedade específica e seu valor
 * @param {T[]} dataList
 * @param {string} property
 * @param {any} value
 * @returns {function(): T[]}
 */
export function filterListByProperty(dataList, property, value) {
  return dataList.filter((data) => data[property].trim() === value)
}
